(function () {
  class CartPage extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.requestId = 0;
      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('change', (event) => this.onChange(event));
    }

    onClick(event) {
      const step = event.target.closest('[data-cart-page-step]');
      const remove = event.target.closest('[data-cart-page-remove]');
      const row = event.target.closest('[data-cart-page-line]');
      if (!row || (!step && !remove)) return;

      event.preventDefault();
      const input = row.querySelector('[data-cart-page-quantity]');
      if (!input) return;

      const quantity = remove ? 0 : Math.max(0, (Number(input.value) || 0) + Number(step.dataset.cartPageStep));
      this.change(Number(row.dataset.cartPageLine), quantity);
    }

    onChange(event) {
      const input = event.target.closest('[data-cart-page-quantity]');
      const row = input && input.closest('[data-cart-page-line]');
      if (!input || !row) return;
      this.change(Number(row.dataset.cartPageLine), Math.max(0, Number(input.value) || 0));
    }

    async change(line, quantity) {
      if (!line) return;
      this.setBusy(true);
      this.showError('');

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity })
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.description || data.message || String(response.status));

        await this.render();
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      } catch (error) {
        this.showError(error.message || this.dataset.cartError);
      } finally {
        this.setBusy(false);
      }
    }

    async render() {
      const id = ++this.requestId;
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(String(response.status));
      const text = await response.text();
      if (id !== this.requestId) return;

      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = doc.querySelector('[data-cart-page-inner]');
      const current = this.querySelector('[data-cart-page-inner]');
      if (!fresh || !current) throw new Error(this.dataset.cartError);
      current.replaceWith(fresh);
    }

    setBusy(state) {
      if (state) this.dataset.busy = 'true';
      else delete this.dataset.busy;
    }

    showError(message) {
      const region = this.querySelector('[data-cart-page-error]');
      if (!region) return;
      region.textContent = message || '';
      region.hidden = !region.textContent;
    }
  }

  if (!customElements.get('cart-page')) customElements.define('cart-page', CartPage);
})();
